var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("vue2-date-picker", {
        staticClass: "w-100",
        attrs: {
          name: _vm.name,
          disabled: _vm.disabled,
          placeholder: _vm.computedPlaceholder,
          "input-class": {
            "mx-input": true,
            "border-danger": _vm.invalid === false
          },
          danger: _vm.invalid,
          type: _vm.type,
          format: _vm.format,
          clearable: _vm.clearable,
          multiple: _vm.multiple,
          range: _vm.range,
          "disabled-date": _vm.disabledDate
        },
        model: {
          value: _vm.date,
          callback: function($$v) {
            _vm.date = $$v
          },
          expression: "date"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }